
export default {
  productData: {
    serialNumber: 'DA-MME-003',
    name: 'Massivholzdecke mit Estrich l Aufbau 3',
    construction: {
      composition: [
        {
          type: 'screed',
          title: { de: 'Estrich' },
          output: '≥ 60',
          value: 'w-60'
        },
        {
          type: 'insulation',
          title: { de: 'Holzfaserdämmplatte WF<br>(<i>s‘</i> ≤ 50 MN/m<sup>3</sup>; Anwendungsgebiet DES-sh)' },
          output: '≥ 20',
          value: 'w-20'
        },
        {
          type: 'fill',
          title: { de: 'Mit StoPrefa Coll SB gebundene Schüttung (<i>m‘</i> ≥ 190 kg/m<sup>2</sup>), Rieselschutz' },
          output: '≥ 120',
          value: 'scsb-120'
        },
        {
          type: 'supportingStructure',
          title: { de: 'Massivholzdecke (Steico GLVL)' },
          output: 120,
          value: 'mh-120'
        }
      ],
      sum: {
        output: '320', value: 320
      }
    },
    technicalValues: {
      impactSoundLevel: { // L,nw
        output: '53 (0; 2)',
        value: 53
      },
      soundReductionIndex: { // Rw
        output: '66 (-2; -9)',
        value: 66
      },
      heatTransferCoefficient: { // U-Wert
        output: '0,50',
        value: 0.50
      },
      fireResistance: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      massPerUnitArea: {
        output: '415 [kg/m²]'
      }
    }
  },
  image: 'da-mme-003.png',
  pdf: 'Massivholzdecke-mit-Estrich-Aufbau-3-DA-MME-003-Rev01.pdf'
}
